import { handleErrors } from '../../js/helpers/handleErrors';
import config from '../../config';
import { store } from '../../store';

const passwordUserChange = (
    currentPassword: string,
    newPassword: string
): Promise<any> => {
    return fetch(config.api.password, {
        method: 'POST',
        headers: { 
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${store.getState().userStore.token}`
        },
        credentials: 'include',
        body: JSON.stringify({
            currentPassword: currentPassword,
            newPassword: newPassword
        })
    })
        .then(handleErrors)
        .then(res => {
            if(res.status === 204) {
                return true
            } else {
                return false
            }
        })
}

export default passwordUserChange